/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { GlobalProvider } from './providers/GlobalProvider';
import NotificationWrapper from 'components/Common/NotificationWrapper';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './api/bitedb/query-client';

import 'resources/styles/MobileResponsive.css';
import 'resources/styles/TabResponsive.css';
import './resources/styles/index.css';
import './resources/styles/business-verification.css';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license';
import Hotjar from './Hotjar.jsx';

import './resources/styles/index.css'; // Load MyComponentB if someCondition is false

//eslint-disable-next-line no-undef
const muiLicense: string = process.env.REACT_APP_MUI_LICENSE!;

LicenseInfo.setLicenseKey(muiLicense);

window.addEventListener('unhandledrejection', (event) => {
  console.warn(event.reason);
});

/* eslint-disable */
const renderApp = async () => {
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <QueryClientProvider client={queryClient}>
      <NotificationWrapper>
        <GlobalProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <BrowserRouter>
              <Hotjar />
              <App />
            </BrowserRouter>
          </LocalizationProvider>
        </GlobalProvider>
      </NotificationWrapper>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
  );
};
renderApp();

serviceWorker.unregister();
